const env = process.env;
// apis
// 'app-type': 'web',
// 'app-version': 'v1',
// 'app-device': 'Postman',
// 'app-device-id': '0',
// 'app-device-os': 'Postman',
// 'format': 'json',
export const HEADERS = {
    'Content-Type': 'application/json',
    // 'x-auth': env.REACT_APP_API_XAUTH,
};
// operators
export const OPERATOR_LOGIN = env.REACT_APP_BASE_URL + env.REACT_APP_API_VERSION + "login/operators";
// app
export const APP_DOWNLOAD_FILE = env.REACT_APP_BASE_URL + env.REACT_APP_API_VERSION + "app/download/file";
// full
export const FULL_TICKETS = env.REACT_APP_BASE_URL + env.REACT_APP_API_VERSION + "tickets";
export const FULL_SCHEDULES = env.REACT_APP_BASE_URL + env.REACT_APP_API_VERSION + "schedules";
export const FULL_SCHEDULES_TICKETS = env.REACT_APP_BASE_URL + env.REACT_APP_API_VERSION + "schedules/tickets";
export const FULL_SCHEDULES_SUB_SCHEDULES = env.REACT_APP_BASE_URL + env.REACT_APP_API_VERSION + "schedules/sub-schedules";
export const FULL_SCHEDULES_SYSTEM_DESTINATIONS = env.REACT_APP_BASE_URL + env.REACT_APP_API_VERSION + "schedules/system-destinations";
export const FULL_SCHEDULES_SCHEDULE_DESTINATIONS = env.REACT_APP_BASE_URL + env.REACT_APP_API_VERSION + "schedules/schedule-destinations";
export const FULL_AGENT_FLOATS = env.REACT_APP_BASE_URL + env.REACT_APP_API_VERSION + "agent-floats";
export const FULL_AGENT_CARD_FLOATS = env.REACT_APP_BASE_URL + env.REACT_APP_API_VERSION + "agent-card-floats";
// full export
export const EXPORT_FULL_TICKETS = env.REACT_APP_BASE_URL + env.REACT_APP_API_VERSION + "tickets/export";
export const EXPORT_FULL_SCHEDULES = env.REACT_APP_BASE_URL + env.REACT_APP_API_VERSION + "schedules/export";
export const EXPORT_FULL_AGENT_FLOATS = env.REACT_APP_BASE_URL + env.REACT_APP_API_VERSION + "agent-floats/export";
export const EXPORT_FULL_AGENT_CARD_FLOATS = env.REACT_APP_BASE_URL + env.REACT_APP_API_VERSION + "agent-card-floats/export";
// full details
export const FULL_TICKETS_DETAILS = env.REACT_APP_BASE_URL + env.REACT_APP_API_VERSION + "tickets/details";
export const FULL_SCHEDULES_DETAILS = env.REACT_APP_BASE_URL + env.REACT_APP_API_VERSION + "schedules/details";
export const FULL_SCHEDULES_SYNC_SEATS = env.REACT_APP_BASE_URL + env.REACT_APP_API_VERSION + "schedules/sync-seats";
// reports
export const REPORTS_TICKETS_HISTORY = env.REACT_APP_BASE_URL + env.REACT_APP_API_VERSION + "reports/tickets";
// reports export
export const REPORTS_TICKETS_HISTORY_EXPORT = env.REACT_APP_BASE_URL + env.REACT_APP_API_VERSION + "reports/tickets/export";
// dropdowns
export const DROPDOWN_COMPANIES = env.REACT_APP_BASE_URL + env.REACT_APP_API_VERSION + "dropdowns/companies";
export const DROPDOWN_COMPANY_BRANCHES = env.REACT_APP_BASE_URL + env.REACT_APP_API_VERSION + "dropdowns/company-branches";
export const DROPDOWN_AGENTS = env.REACT_APP_BASE_URL + env.REACT_APP_API_VERSION + "dropdowns/agents";
export const DROPDOWN_POS = env.REACT_APP_BASE_URL + env.REACT_APP_API_VERSION + "dropdowns/pos";
export const DROPDOWN_BUSES = env.REACT_APP_BASE_URL + env.REACT_APP_API_VERSION + "dropdowns/buses";
export const DROPDOWN_ROUTES = env.REACT_APP_BASE_URL + env.REACT_APP_API_VERSION + "dropdowns/routes";
export const DROPDOWN_DESTINATIONS = env.REACT_APP_BASE_URL + env.REACT_APP_API_VERSION + "dropdowns/destinations";

